export { Icon } from './Icon';
export type { IconProps } from './Icon';
export { getIcon } from './getIcon';
